import { AppModule } from '@/store/modules/app'
import { Message, MessageBox } from 'element-ui'
import { checkNeedAudit } from './permission'

/**
 * 接口访问拦截器
 * @param ops 
 * title    弹窗标题
 * key      参数名：description 或 google_code
 * fn       请求方法
 * params   请求参数    
 */
export const reqInterceptors = (ops: any) => {
    try {
        if (ops.key === 'description' && checkNeedAudit(ops.authCode)) {
            MessageBox.prompt(ops.title + '：', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                inputPlaceholder: checkNeedAudit(ops.authCode),
                inputValidator: function(v) { return v !== null && (v + '').length > 0},
                inputErrorMessage: 'Please enter description!'
            }).then(({value}: any) => {
                const data: any = {
                    ...ops.params,
                    [ops.key]: value
                }
                ops.fn(data)
            })
        } else if (ops.key === 'google_code' && AppModule.enterprise.google_auth_switch) {
            MessageBox.prompt(ops.title + '：', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                inputValidator: function(v) { return v !== null && (v + '').length > 0},
                inputErrorMessage: 'Please enter a verification code!'
            }).then(({value}: any) => {
                const data: any = {
                    ...ops.params,
                    [ops.key]: value
                }
                ops.fn(data)
            })
        } else {
            ops.fn(ops.params)
        }
    } catch(e) {
        
    }
}